// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"5d3380f0","583":"64cfbf69","845":"42d72e95","983":"0112b2d6"}[chunkId] + ".chunk.js";
};